import React from 'react'
import 'raf/polyfill'
import 'babel-polyfill'
import { connect } from 'react-redux'
import comFn from '../../component/common/common'
import axios from 'axios'
import HeaderBar from '../../component/header/header.js'
import LeftNav from '../../component/left-nav/leftNav.js'
import Login from '../../component/login/login.js'
import './message.css'
import PagingBar from'../../component/paging-bar/paging.js'
import {pagingFn} from '../../redux/message.redux.js'
import {reduceMsgNum} from '../../redux/chatuser.redux.js'
import {userList} from '../../redux/chatuser.redux.js'
import {getLoginURL} from '../../util.js'
import {getBigBGUrl} from '../../redux/chatuser.redux.js'
@connect(
  state=>state.message,
  {pagingFn,reduceMsgNum,userList,getBigBGUrl}
)
@connect(
  state=>state.chatuser,
  {reduceMsgNum,userList}
)
class MyMessage extends React.Component{
	constructor(props){
		super(props)
		
		this.state={
			msgData:{},
			
		
			'allCheckEd':false,
			 msgStyle:0,
			 currentPage: 1, //当前页码
			 pageSize:10 //每页显示的条数
			 
  		      		
    	} 
    	this.pageNext  = this.pageNext.bind(this)		
	}

	componentDidMount(){
    
    	this.getMessage(0)
    	this.getMessageType()

 
  	}
  	
  	getMessage(pIndex){
  		const _this = this
  		const {pageSize,msgStyle} = this.state
  	
  		axios.get('fapi/notices/getNoticesList?page_index='+pIndex+'&limit='+pageSize+'&category='+msgStyle+'')
	      .then(res=>{
	      	
	      	if(res.data.return_code!==0){return}
	      	res.data.data.map((item,i)=>{
	      		item.msgOpt = {
	      			"icheck":false,
	      			'iRead':false
	      			//'msgDetail':''
	      		}
	      	})
	      	this.setState({
	      		msgData:res.data,
	      		allCheckEd:false

	      	})
	       
     
	    })  
  	}

  	pageNext(num){
		this.setState({
			currentPage:num
		})
		this.getMessage(num)
  	}
	getMessageType(){
  		const _this = this
  		axios.get('fapi/notices/getNoticeCates')
	      .then(res=>{
	      	
	      	
	    })  
  	}
  	tabMsg(num){
  		
  		this.setState({
  			msgStyle:num
  		},function () {
  			this.getMessage(1)
  		})
		

  	}
  	allCheckFn(){
  		var idata = this.state.msgData
		this.setState({
	  		allCheckEd:!this.state.allCheckEd
	  	})
  		if(this.state.allCheckEd){
			for(let i=0;i<idata.data.length;i++){
	  			idata.data[i].msgOpt.icheck = false
	  		}

  		}else{
  			for(let i=0;i<idata.data.length;i++){
	  			idata.data[i].msgOpt.icheck = true
	  		}
  		}
  		this.setState({
	  		msgData:idata
	  	})

  	}
  	checkOff(i){
  		
  		const _this = this
  		var mdata = this.state.msgData
  		mdata.data[i].msgOpt.icheck = !mdata.data[i].msgOpt.icheck
  		this.setState({
  			msgData:mdata
  		})
  		const idata = this.state.msgData.data
  		var  inum = 0
  		
		for(let j=0;j<idata.length;j++){
			if(idata[j].msgOpt.icheck){
				inum++
				
				if(inum==idata.length){
					
					_this.setState({
						allCheckEd:true
					})
				}
			}
			if(!idata[j].msgOpt.icheck){
				_this.setState({
					allCheckEd:false
				})
			}
		}
		
  	}
  	showMsgDetail(i,idx,thispt){
  		
  		const _this = this
  		var idata = this.state.msgData
  		axios.get('/fapi/notices/changeToRead?id='+idx+'' + (thispt !== '' ? '&thispt=' + thispt : ''))
  			.then(res=>{
  				
  				for(let j=0;j<idata.data.length;j++){
  					if(j===i){continue}
					idata.data[j].msgOpt.iRead = false
  				}

  				idata.data[i].msgOpt.iRead = !idata.data[i].msgOpt.iRead
  				
  				idata.data[i].read = 1
  				this.setState({
		  			'msgData':idata
		  		})
  				if(res.data.return_code==0){
					
								
						this.props.reduceMsgNum()
						
  				}
  				

  				
				
  			})
		
  	}
  	deleteMsg(i,idx){
  		
  		const idata = JSON.parse(JSON.stringify(this.state.msgData))
  		var str = []
  		var str2 = []
  		for(let j=0;j<idata.data.length;j++){
  			if(idata.data[j].msgOpt.icheck){
  				
  				str.push(idata.data[j].id + ':' + idata.data[j].thispt)
				str2.push(j)
				idata.data.splice(j,1)
				j--
  				
  			}
			
  		}
		if(str.length==0){
			return
		}
  		var ids = str;
  		
		
  		axios.get('fapi/notices/delete?ids='+ids+'')
	  		.then(res=>{
	  			
				if(res.data.return_code==0){
					for(var i=0;i<str2.length;i++){
						var inum = str2[i]
						if(this.state.msgData.data[inum].read==0){
							
							this.props.reduceMsgNum()
						}

					}
					
					this.setState({
			  			msgData:idata
			  		})
			  		if(str2.length==this.state.pageSize||idata.data.length==0){
			  			this.pageNext(1)
			  		}
				}
	  		})
  		
  	}
  	
  	handleMsgTime(iTime){
  		var mTime = iTime?iTime.substring(0,10):''
  		
  		return mTime
  	}
  	render(){
  		
    	this.props.userlist.code?()=>getLoginURL(this.props.location.pathname):null
		return (
			<div className="my-wrap" style={{backgroundImage :'url('+this.props.bigBg+')'}}>
				<HeaderBar></HeaderBar>
				<div className="my-message-box">
					<Login showLogin={this.props.showLogin}>
		                
		                
		            </Login>
					<div className="my-message-con">
						<div>
							<div className="message-nav" >
								<span className={this.state.msgStyle==0?'active':''} onClick={()=>this.tabMsg(0)}>全部消息</span>
								<span  className={this.state.msgStyle==1?'active':''} onClick={()=>this.tabMsg(1)}>游戏礼包</span>
								<span  className={this.state.msgStyle==2?'active':''} onClick={()=>this.tabMsg(2)}>系统消息</span>

							</div>
							<div className="no-message-box" 
								style={this.state.msgData.data&&this.state.msgData.data.length==0?
									{display:'block'}:{display:'none'}}>
							</div>
							<ul className="messages-list" 
								style={this.state.msgData.data&&this.state.msgData.data.length==0?
									{display:'none'}:{display:'block'}}>
							{
								this.state.msgData.data&&this.state.msgData.data.map((item,i)=>{
									
									return (
									
										<li key={i}>
											<div className="list-con">
												 <label name="ae"  className={item.msgOpt.icheck?'checked':''} onClick={()=>this.checkOff(i)}></label>
												 <span 
												 	className={item.read==0?"msg-list-box":' msg-list-box open'} 
												 	onClick={()=>this.showMsgDetail(i,item.id,item.thispt)}>
												 	<strong className="istrong">{item.title}</strong>
												 	<em>{this.handleMsgTime(item.start_time)}</em>
												 </span>
											 </div>
											 {
												 item.msgOpt.iRead&&<div className="msg-detail" >
												 	<div dangerouslySetInnerHTML={{ __html: item.content}}></div>

												 </div>
											 }
										</li>
									)
								})
							}
								
								

							</ul>
							<div className="allCheck-box" 
								style={this.state.msgData.data&&this.state.msgData.data.length==0?
									{display:'none'}:{display:'block'}}>
								 <label 
									 name="ae"  
									 className={this.state.allCheckEd?'checked allCheck':'allCheck'}
									 onClick={this.allCheckFn.bind(this)}
								 >全选</label>
								 <a href="javascript:;" className="delete" onClick={()=>this.deleteMsg()}>删除</a>
							</div>
							{
								this.state.msgData.data&&this.state.msgData.data.length!=0?
								<PagingBar 
									pageNext={this.pageNext} 
									totalPage={this.state.msgData.total_page}
								></PagingBar>:null
							}
							
							

						</div>

					</div>
					<LeftNav 
						myTitle="个人中心"						
						optData={["","","left-nav-active my-message-btn"]}
						childData={["我的会员","我的福利","我的消息"]}
					>
					
					</LeftNav>

				</div>


			</div>
		)
  	}
 }
 export default MyMessage


// WEBPACK FOOTER //
// ./src/container/my-message/message.js